function Login() {
  return <div className="main-container">
    <div></div>
    <div></div>
  </div>;
}

export default Login;
